export default __webpack_public_path__ + "static/media/score-bg.44b05055.png";